export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const FETCH_ALL = 'FETCH_ALL';
export const FETCH_ONE = 'FETCH_ONE';
export const LIKE = 'LIKE';

export const START_LOADING = 'START_LOADING';
export const END_LOADING = 'END_LOADING';

export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';

export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSOWRD_FAIL';

export const FETCH_BENCHES_REQUEST = 'FETCH_BENCHES_REQUEST';
export const FETCH_BENCHES_SUCCESS = 'FETCH_BENCHES_SUCCESS';
export const FETCH_BENCHES_FAILURE = 'FETCH_BENCHES_FAILURE';

export const FETCH_BENCH_VIDEOS_REQUEST = 'FETCH_BENCH_VIDEOS_REQUEST';
export const FETCH_BENCH_VIDEOS_SUCCESS = 'FETCH_BENCH_VIDEOS_SUCCESS';
export const FETCH_BENCH_VIDEOS_FAILURE = 'FETCH_BENCH_VIDEOS_FAILURE';
